import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, ArrowLeft } from 'lucide-react';
import { Badge } from '../../components/ui/badge';

const TerminosPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <section className="bg-teal-600 py-12">
        <div className="container-max mx-auto px-4 md:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-teal-100 hover:text-white mb-4">
            <ArrowLeft className="w-4 h-4" />
            Volver al inicio
          </Link>
          <Badge className="bg-white/20 text-white hover:bg-white/20 mb-4">
            <FileText className="w-3 h-3 mr-1" />
            Legal
          </Badge>
          <h1 className="font-heading text-3xl md:text-4xl font-semibold text-white">
            Términos y Condiciones
          </h1>
          <p className="text-teal-100 mt-2">Última actualización: [Fecha]</p>
        </div>
      </section>

      {/* Content */}
      <section className="section-padding">
        <div className="container-max mx-auto">
          <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-soft p-8 md:p-12">
            <div className="prose prose-slate max-w-none">
              <h2>1. Identificación del prestador</h2>
              <p>
                <strong>[Razón Social]</strong>, RUT [RUT], con domicilio en [Dirección], [Ciudad], Chile
                (en adelante, "AnonimaMente" o "la Plataforma").
              </p>
              <p>
                Email de contacto: [email@anonimamente.cl]
              </p>

              <h2>2. Objeto del servicio</h2>
              <p>
                AnonimaMente es una plataforma de intermediación tecnológica que conecta a usuarios 
                (pacientes) con profesionales de la psicología (psicólogos) para la realización de 
                sesiones de telepsicología. La Plataforma facilita:
              </p>
              <ul>
                <li>El agendamiento de citas</li>
                <li>El procesamiento de pagos</li>
                <li>La provisión de infraestructura tecnológica para videollamadas</li>
              </ul>
              <p>
                <strong>Importante:</strong> AnonimaMente no presta directamente servicios de atención 
                psicológica. El profesional es el único responsable de la atención clínica brindada.
              </p>

              <h2>3. Naturaleza del servicio - No es urgencias</h2>
              <p>
                AnonimaMente <strong>NO es un servicio de emergencias ni crisis</strong>. Si experimentas 
                una crisis de salud mental, ideas suicidas, o situación de riesgo vital, debes contactar 
                inmediatamente:
              </p>
              <ul>
                <li>Salud Responde: 600 360 7777</li>
                <li>Fono Ayuda: *4141</li>
                <li>Urgencias del centro de salud más cercano</li>
              </ul>

              <h2>4. Registro y anonimato</h2>
              <p>
                Para usar el servicio, el usuario debe proporcionar un <strong>seudónimo</strong> 
                (nombre ficticio). No se requiere nombre real, RUT, ni documento de identidad.
              </p>
              <p>
                El email es opcional y solo se usa para enviar recordatorios si el usuario lo desea.
              </p>

              <h2>5. Profesionales</h2>
              <p>
                Todos los psicólogos de la Plataforma:
              </p>
              <ul>
                <li>Están titulados en universidades reconocidas</li>
                <li>Poseen registro profesional verificado</li>
                <li>Aceptan el código de ética y confidencialidad de AnonimaMente</li>
              </ul>
              <p>
                El usuario puede acceder a las credenciales verificadas de cada profesional antes de agendar.
              </p>

              <h2>6. Tarifas y pagos</h2>
              <p>
                Las tarifas son fijadas por cada profesional y se informan claramente antes de la reserva.
                El pago se realiza por adelantado a través de los medios habilitados:
              </p>
              <ul>
                <li>Webpay (débito/crédito)</li>
                <li>Flow / Khipu (transferencia)</li>
                <li>Bitcoin (BTCPay Server)</li>
              </ul>
              <p>
                Se emite <strong>boleta electrónica</strong> por cada transacción.
              </p>

              <h2>7. Política de cancelación</h2>
              <p>
                Las cancelaciones realizadas con al menos <strong>[X] horas</strong> de anticipación 
                tendrán derecho a reembolso completo o reagendamiento sin costo.
              </p>
              <p>
                Las cancelaciones tardías o inasistencias están sujetas a las políticas de cada 
                profesional, que pueden incluir cobro parcial o total de la sesión.
              </p>

              <h2>8. Privacidad y datos</h2>
              <p>
                El tratamiento de datos personales se rige por nuestra 
                <Link to="/legales/privacidad" className="text-teal-600"> Política de Privacidad</Link>.
              </p>
              <p>
                Las sesiones <strong>nunca se graban</strong> por parte de la Plataforma.
              </p>

              <h2>9. Limitación de responsabilidad</h2>
              <p>
                AnonimaMente actúa como intermediario tecnológico. No es responsable por:
              </p>
              <ul>
                <li>El contenido o calidad de la atención clínica brindada por los profesionales</li>
                <li>Resultados terapéuticos esperados o no alcanzados</li>
                <li>Decisiones tomadas por el usuario basadas en las sesiones</li>
              </ul>

              <h2>10. Propiedad intelectual</h2>
              <p>
                Todos los contenidos de la Plataforma (marca, diseño, textos, código) son propiedad 
                de [Razón Social] y están protegidos por las leyes de propiedad intelectual aplicables.
              </p>

              <h2>11. Modificaciones</h2>
              <p>
                AnonimaMente se reserva el derecho de modificar estos términos. Los cambios se 
                comunicarán con al menos 15 días de anticipación.
              </p>

              <h2>12. Ley aplicable y jurisdicción</h2>
              <p>
                Estos términos se rigen por las leyes de la República de Chile. Cualquier controversia 
                será sometida a los tribunales ordinarios de [Ciudad], Chile.
              </p>

              <hr className="my-8" />

              <p className="text-sm text-slate-500">
                Si tienes dudas sobre estos términos, contáctanos en [email@anonimamente.cl].
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TerminosPage;
